import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { OfferNewCarOrderIdVehicleDataPathParams } from "./OfferNewCarOrderIdVehicleDataPathParams"
import type { OfferVehicleDataView } from "./OfferVehicleDataView"

export const getVehicleDataByNewCarOrderIdForCsvOfferRoute: ApiRoute<
	OfferNewCarOrderIdVehicleDataPathParams,
	NoQueryParams,
	NoBody,
	OfferVehicleDataView
> = {
	buildUrl: ({ newCarOrderId }) => `/offers/vehicle-data/csv/new-car-order-id/${newCarOrderId}`,
	method: "get",
	path: "/offers/vehicle-data/csv/new-car-order-id/:newCarOrderId",
}
